// @core/api/endpoints/team/delete_team_banner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/team';

/**
 * Delete team banner
 * Removes the team's banner image. The team profile will display without a banner until a new one is uploaded.
 */
export async function DeleteTeamBanner(
  team_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/banner`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
